import React from "react";
import { Collapse, Card, Tag, Typography } from "antd";

const { Panel } = Collapse;
const { Title, Text } = Typography;

const UserLocations = ({ userLocations }) => {
  // Step 1: Separate parent and child locations
  const parentLocations = userLocations.filter((loc) => !loc.parent_id);
  const childLocations = userLocations.filter((loc) => loc.parent_id);

  // Step 2: Group child locations under their parent
  const childrenByParent = childLocations.reduce((acc, loc) => {
    if (!acc[loc.parent_id]) acc[loc.parent_id] = [];
    acc[loc.parent_id].push(loc);
    return acc;
  }, {});

  // Step 3: Group parent locations by city
  const cities = parentLocations.reduce((acc, loc) => {
    const cityName = loc.city_name || "Unknown City";
    if (!acc[cityName]) acc[cityName] = [];
    acc[cityName].push(loc);
    return acc;
  }, {});

  return Object.keys(cities).length === 0 ? (
    <Typography.Text type="secondary">No location allocated</Typography.Text>
  ) : (
    <Collapse accordion>
      {Object.entries(cities).map(([city, buildings]) => (
        <Panel header={city} key={city}>
          {buildings.map((building) => (
            <Card
              key={building.id}
              title={building.name}
              size="small"
              style={{ marginBottom: 12 }}
            >
              {(childrenByParent[building.id] || []).length > 0 ? (
                childrenByParent[building.id].map((child) => (
                  <Tag key={child.id} color="blue">
                    {child.name}
                  </Tag>
                ))
              ) : (
                <Typography.Text type="secondary">
                  No child locations
                </Typography.Text>
              )}
            </Card>
          ))}
        </Panel>
      ))}
    </Collapse>
  );
};

export default UserLocations;
